import { useStyles } from './style';

interface BarProps {
	style?: object;
}

/**
 * Mui Material linearprogress should be used instead of this
 * @param props
 * @returns
 * @deprecated
 */
const Bar = (props: BarProps) => {
	const classes = useStyles();
	return <span className={classes.loadingBar} style={{ ...props.style }} />;
};

export default Bar;
